import useGetAudioSchema from '../../../../API/hooks/devices/useGetAudioSchema';
import useGetFleetId from '../../../../API/hooks/useGetFleetId';
import useGetRole from '../../../../API/hooks/useGetRole';
import { AudioSchema } from '../../../../API/types/AudioSchemas';
import { Button } from '../../../../components/ui/Button/Button';
import { ALERT_AUDIO_NAMES } from '../../../../constants/AlertConfig';
import AlertSchemaItem from './AlertSchemaItem';
import S from './AlertSchemaStyles';

type Props = {
  item?: AudioSchema;
  toggleModal?: any;
  readOnly?: boolean;
};

function AlertSchema({ item, toggleModal, readOnly = false }: Props): JSX.Element {
  const fleetId = useGetFleetId();
  const { data: schema, isLoading } = useGetAudioSchema(fleetId, item?._id || '');

  if (isLoading) {
    return (<S.Wrapper><p>Loading...</p></S.Wrapper>);
  }

  return (
    <S.Wrapper>
      <h3>Alert Schema - {item?.name}</h3>
      {Object.entries(ALERT_AUDIO_NAMES).map(([audioKey, value]) => (
        <AlertSchemaItem
          audioBundleId={schema?._id}
          label={value}
          audioKey={audioKey}
          key={audioKey}
          audio={(schema as any)?.audioSchema?.[audioKey]?.url}
          readOnly={readOnly}
        />
      ))}
      <Button
        className="close-btn"
        onClick={() => toggleModal(false)}
      >
        Close
      </Button>
    </S.Wrapper>
  );
}

export default AlertSchema;
